const blockSelector = '.free-shipping-message';
const subtotalSelector = '.wc-block-mini-cart__footer-subtotal .wc-block-components-totals-item__value';
const drawerSelector = '.wc-block-mini-cart__drawer';

let lastSubtotalText = '';
let subtotalObserver = null;

function parsePrice(value) {
    const normalized = String(value || '')
        .replace(/\s/g, '')
        .replace(/[^\d,.-]/g, '')
        .replace(',', '.');

    const price = Number.parseFloat(normalized);

    return Number.isFinite(price) ? price : 0;
}

function formatPrice(value) {
    return new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: 'PLN',
    }).format(value);
}

function updateBlock(block) {
    const min = Number.parseFloat(block.dataset.min || '0');
    const text = block.dataset.text || '';
    const subtotal = parsePrice(document.querySelector(subtotalSelector)?.textContent);
    const missing = min - subtotal;

    if (!min || !text || missing <= 0) {
        block.hidden = true;
        block.textContent = '';
        return;
    }

    block.textContent = text.replace('%s', formatPrice(missing));
    block.hidden = false;
}

function updateBlocks() {
    document.querySelectorAll(blockSelector).forEach(updateBlock);
}

function getSubtotalText() {
    return document.querySelector(subtotalSelector)?.textContent?.trim() || '';
}

function syncIfSubtotalChanged() {
    const subtotalText = getSubtotalText();

    if (!subtotalText || subtotalText === lastSubtotalText) {
        return;
    }

    lastSubtotalText = subtotalText;
    updateBlocks();
}

function observeMiniCartSubtotal() {
    if (subtotalObserver) {
        return;
    }

    const drawer = document.querySelector(drawerSelector);

    if (!drawer) {
        return;
    }

    subtotalObserver = new MutationObserver(syncIfSubtotalChanged);
    subtotalObserver.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true,
    });

    syncIfSubtotalChanged();
}

export default function initializeFreeShippingMessage() {
    if (!document.querySelector(blockSelector)) {
        return;
    }

    observeMiniCartSubtotal();
    document.addEventListener('click', () => window.requestAnimationFrame(observeMiniCartSubtotal));
}
